import { createAsyncThunk } from '@reduxjs/toolkit'
import ContentCreatorInvitation from './content-creator-invitation-model'
import {
  delete_contentCreatorInvitation,
  load_contentCreatorInvitations,
  store_contentCreatorInvitation,
} from './contentCreatorInvitation-service'

export const LoadContentCreatorInvitationsAsync = createAsyncThunk<any, any>(
  'composer/load/contentCreatorInvitation',
  async (params: { uid: string }) => {
    return await load_contentCreatorInvitations(params)
  },
)

export const CreateContentCreatorInvitationAsync = createAsyncThunk<any, any>(
  'composer/create/contentCreatorInvitation',
  async (params: ContentCreatorInvitation) => {
    return await store_contentCreatorInvitation(params)
  },
)

export const DeleteContentCreatorInvitationAsync = createAsyncThunk<any, any>(
  'composer/delete/contentCreatorInvitation',
  async (params) => {
    return await delete_contentCreatorInvitation(params)
  },
)
